import { render, staticRenderFns } from "./GBoothEdit.vue?vue&type=template&id=1cd0d8c0&scoped=true&"
import script from "./GBoothEdit.vue?vue&type=script&lang=ts&"
export * from "./GBoothEdit.vue?vue&type=script&lang=ts&"
import style0 from "./GBoothEdit.vue?vue&type=style&index=0&id=1cd0d8c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd0d8c0",
  null
  
)

export default component.exports